// App.js
import React, { useState } from 'react';
import TodoList from './components/TodoList';
import './App.css';

function App() {
  const [todoLists, setTodoLists] = useState([]);

  const createNewList = () => {
    const newListId = Math.max(...todoLists, 0) + 1;
    setTodoLists([...todoLists, newListId]);
  };

  const removeList = (id) => {
    const updatedLists = todoLists.filter((listId) => listId !== id);
    setTodoLists(updatedLists);
  };

  return (
    <div className="App">
      {todoLists.map((listId) => (
        <TodoList key={listId} id={listId} onRemove={removeList} />
      ))}
      <button onClick={createNewList} className="create-new-list">
        Create New List
      </button>
    </div>
  );
}

export default App;
